export default function AdminGeneralSourceTypeAccess() {
  return (
    <div className="flex min-h-9 flex-wrap items-center gap-2.5">
      <button
        type="button"
        disabled
        aria-label="All Types. Admin has access to all source types."
        className="inline-flex min-h-9 cursor-not-allowed items-center gap-1.5 rounded-lg border border-gray-200 bg-gray-100 px-3 text-xs font-medium text-gray-600"
      >
        <i className="ri-lock-line text-gray-400" aria-hidden="true" />
        <span>All Types</span>
      </button>
      <span className="text-[11px] text-gray-400">Admin has access to all source types</span>
    </div>
  );
}
